
export enum EnumSocket {
  Open = 'Open',
  Close = 'Close',
  Nada = 'Nada',
  AgregarExpIns = 'AgregarExpIns',
  ModificarExpIns = 'ModificarExpIns',
  ModificarConcepto = 'ModificarConcepto',
  ModificarMatriz = 'ModificarMatriz',
  ModificarCH = 'ModificarCH',
  BorrarExpIns = 'BorrarExpIns',
  UserOnline = 'UserOnline',
  EnEdicionPartida = 'EnEdicionPartida',
  EnEdicionConcepto = 'EnEdicionConcepto',
  EnEdicionMatriz = 'EnEdicionMatriz',
  AgregarPartida = 'AgregarPartida',
  RenombrarPartida = 'RenombrarPartida',
  MoverPartida = 'MoverPartida',
  ModificarPartida = 'ModificarPartida',
  BorrarPartida = 'BorrarPartida',
  PendienteAnalizar = 'PendienteAnalizar',
}
